import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         // formControl: {
//         //     margin: theme.spacing(1),
//         //     position: 'relative',
//         //     top: '0.55rem',
//         //     // minWidth: 320,
//         // },
//         // textField: {
//         //     marginLeft: theme.spacing(1),
//         //     marginRight: theme.spacing(1),
//         //     width: "18rem",
//         // },
//         // select: {
//         //     width: "10rem",
//         // },
//         // bottomControlLabel: {
//         //     verticalAlign: 'bottom',
//         //     marginLeft: theme.spacing(1),
//         // },
//         // boldLabel: {
//         //     marginTop: "1rem",
//         //     fontWeight: 900
//         // }
//     }),
// );

export default function PersonaFisicaImprenditore(props: SchedaBudgetInputProps) {

    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeImposteContributi";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;

        if (name === "F68_artigiano" && checked === true && state.imposteContributi.F69_commerciante === true)
            state.imposteContributi.F69_commerciante = false;
        else if (name === "F69_commerciante" && checked === true && state.imposteContributi.F68_artigiano === true)
            state.imposteContributi.F68_artigiano = false

        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, name, checked, action, true);
    };

    return (
        <Paper className={gClasses.fullWidthPaper}>
            <Grid container>
                <SectionSubTitle text="Tipologia"></SectionSubTitle>
                <Grid container>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F68_artigiano}
                                name='F68_artigiano'
                                id='F68_artigiano'
                                value={state.imposteContributi.F68_artigiano}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Artigiano"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F69_commerciante}
                                name='F69_commerciante'
                                id='F69_commerciante'
                                value={state.imposteContributi.F69_commerciante}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Commerciante"
                    />
                </Grid>
            </Grid>
            <SectionSubTitle text="Carichi familiari"></SectionSubTitle>
            <Grid container direction="row" justify="flex-start" alignItems="flex-end">
                <FormControlLabel className={gClasses.bottomControlLabel} 
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H69_coniuge}
                            name='H69_coniuge'
                            id='H69_coniuge'
                            value={state.imposteContributi.H69_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge" />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="I68_nfigli">N. Figli</InputLabel>
                    <Select
                        className={gClasses.selectIForf}
                        value={state.imposteContributi.I69_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I69_nfigli', id: 'I69_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="J68_pfigli">'% Figli</InputLabel>
                    <Select
                        className={gClasses.selectIForf}
                        value={state.imposteContributi.J69_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J69_pfigli', id: 'J69_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Paper>
    )
}